<template>
<div>
  <div class="row">
    <div class="col">
      <button type="button"
        class="btn u-mb-20"
        @click="$router.go(-1)"
      >
        <i class="fa fa-arrow-left"></i>
        &nbsp; Volver
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <ul class="nav nav-tabs nav-justified">
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('inspirador')" :class="{ active: isActive('inspirador') }" href="#inspirador">Detalle</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('inspirados')" :class="{ active: isActive('inspirados') }" href="#inspirados">Inspirados</a>
          </li>
      </ul>
    </div>
    <div class="col-sm-12">
      <div class="tab-content pt-5">
        <div class="tab-pane fade" :class="{ 'active show': isActive('inspirador') }" id="inspirador">
          <card class="col-md-8 offset-md-2" header-text="Detalle Inspirador">
              <ul v-if="hasInspiradores" class="list-group list-group-flush">
                    <li class="list-group-item"><h4>
                      <span><strong>{{ `${inspirador.nombres} ${inspirador.apellidos}`  }}</strong></span>
                    </h4></li>
                    <li v-if="inspirador.edad" class="list-group-item">Edad:
                      <span><strong>{{ inspirador.edad }}</strong></span>
                    </li>
                    <li class="list-group-item">Tipo identificación:
                      <span><strong>{{ inspirador.tipoIdentificacion }}</strong></span>
                    </li>
                    <li class="list-group-item">Número identificación:
                      <span><strong>{{ inspirador.numeroIdentificacion }}</strong></span>
                    </li>
                    <li v-if="inspirador.telefono" class="list-group-item">Teléfono:
                      <span><strong>{{ inspirador.telefono }}</strong></span>
                    </li>
                    <li class="list-group-item">Correo:
                      <span><strong>{{ inspirador.correo }}</strong></span>
                    </li>
                    <li class="list-group-item">Nacionalidad:
                      <span><strong>{{ inspirador.pais }}</strong></span>
                    </li>
                    <li v-if="inspirador.departamento.nombre" class="list-group-item">Departamento:
                      <span><strong>{{ inspirador.departamento.nombre }}</strong></span>
                    </li>
                    <li v-if="inspirador.municipio.nombre || inspirador.municipio.nombreMunicipio" class="list-group-item">Municipio:
                      <span><strong>{{ inspirador.municipio.nombre || inspirador.municipio.nombreMunicipio }}</strong></span>
                    </li>
                    <li v-if="inspirador.direccion" class="list-group-item">Dirección:
                      <span><strong>{{ inspirador.direccion }}</strong></span>
                    </li>
                    <li class="list-group-item">Facilitador:
                      <span><strong>{{ inspirador.facilitador }}</strong></span>
                    </li>
                    <li class="list-group-item">Tipo Organización:
                      <span><strong>{{ inspirador.organizacionTipo }}</strong></span>
                    </li>
                    <li v-if="inspirador.organizacionTipo === 'Persona Natural'" class="list-group-item">Nombre Organización:
                      <span><strong>{{ inspirador.organizacionNombre }}</strong></span>
                    </li>
                    <li class="list-group-item">Género:
                      <span><strong>{{ inspirador.genero }}</strong></span>
                    </li>
                    <li class="list-group-item">Etnia:
                      <span><strong>{{ inspirador.etnia }}</strong></span>
                    </li>
                    <li v-if="inspirador.victima" class="list-group-item">Víctima:
                      <span><strong>Sí</strong></span>
                    </li>
                    <li v-if="inspirador.discapacidad" class="list-group-item">Discapacidad:
                      <span><strong>Sí</strong></span>
                    </li>
                    <li v-if="inspirador.lgbti" class="list-group-item">Lgbti:
                      <span><strong>Sí</strong></span>
                    </li>
                    <li v-if="inspirador.createdAt" class="list-group-item">Creado:
                      <span><strong>{{ inspirador.createdAt }}</strong></span>
                    </li>
                </ul>
          </card>
        </div>
        <div class="tab-pane fade" :class="{ 'active show': isActive('inspirados') }" id="inspirados">
            <Inspirados title="Sus inspirados" :userToken.sync="keyInspirador" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script>
<script src="https://code.jquery.com/jquery-3.3.1.slim.min.js" integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js" integrity="sha384-UO2eT0CpHqdSJQ6hJty5KVphtPhzWj9WO1clHTMGa3JDZwrnQq4sF86dIHNDz0W1" crossorigin="anonymous"></script>
<script src="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js" integrity="sha384-JjSmVgyd0p3pXB1rRibZUAYoIIy6OrQ6VrjIEaFf/nJGzIxFDsf4x0xIM+B07jRM" crossorigin="anonymous"></script>
<script>

import { obtenerInspiradores} from '../../api/admin'
import { obtenerInspiradorPorId } from '../../api/inspiradores'
import { getUserInfo } from '../../api/auth'
import { mapState } from 'vuex'
import Inspirados from '../inspirados/Inspirados'
import { etnias, generos, instituciones, tiposDocumento } from '../../static-data/listas'

export default {
  components: { Inspirados },
  data() {
    return {
      inspiradores: [],
      inspirador: {},
      keyInspirador: '',
      activeItem: 'inspirador'
    }
  },
  async mounted() {
    if (this.user !== {}) await this.$store.dispatch('user/getUserInfo')
    this.keyInspirador = this.$route.params.id
    await this.loadInspirador(this.$route.params.id)

    const rol = this.user.rol && this.user.rol.toLowerCase()
    if ((rol !== 'merani') && (rol !== 'admin')) {
      this.$router.push({ path: '/' })
    }
    await this.loadFacilitator(this.inspirador.facilitador)

    this.inspirador.tipoIdentificacion = tiposDocumento.filter(o => o.value === this.inspirador.tipoIdentificacion)[0].label
    this.inspirador.genero = generos.filter(o => o.value === this.inspirador.genero)[0].label
    this.inspirador.organizacionTipo = instituciones.filter(o => o.value === this.inspirador.organizacionTipo)[0].label
    this.inspirador.etnia = etnias.filter(o => o.value === this.inspirador.etnia)[0].label
    if(this.inspirador.createdAt){
      const tempDate = new Date(this.inspirador.createdAt)
      const dd = String(tempDate.getDate()).padStart(2, '0')
      const mm = String(tempDate.getMonth() + 1 ).padStart(2, '0')
      const yyyy = tempDate.getFullYear()
      this.inspirador.createdAt = dd + '/' + mm + '/' + yyyy
    }
  },
  methods: {
    async loadInspirador(id) {
      const inspiradorDoc = await obtenerInspiradorPorId(id)
      this.inspirador = inspiradorDoc.data()
    },
    async loadFacilitator(id) {
      const facilitador = await getUserInfo(id)
      this.inspirador.facilitador = facilitador.data().nombres + " " + facilitador.data().apellidos
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    }

  },
  computed: {
    ...mapState('user', [
      'token',
      'user'
    ]),
    hasInspiradores() {
      return Object.keys(this.inspirador).length
    }
  }
}
</script>
<style lang="scss" scoped>
  .u-mb-20 {
    margin-bottom: 20px;
  }
  video, audio {
    width: 100%;
  }
  .btn-small {
    font-size: 12px;
    padding: 5px 9px;
  }
  li>span{
    float:right;
  }
</style>
